import dynamicLocalization from "@/mixins/dynamic-localization";
import FormFieldGroup from "./group/index";
import FormVerification from "./form-submit/index";
import PinEntry from "@/components/pin-entry/index";
import standardRequest from "@/mixins/request/standard";

export default {
  props: {
    formInfo: {
      type: Object,
      required: true,
    },
    formKey: {
      type: String,
      required: true,
    },
  },
  components: {
    FormFieldGroup,
    FormVerification,
    PinEntry,
  },
  data() {
    return {
      formData: {}, // user input to populate external form info
      submitted: false,
      submissionInProgress: false,
      verificationTriggered: false,
      transmissionPIN: null,
      formId: null,
      error: null,
    };
  },
  mixins: [dynamicLocalization, standardRequest],
  methods: {
    onFormFieldUpdate(fieldData) {
      const { fieldKey, value } = fieldData;
      this.$set(this.formData, fieldKey, value);
    },
    submit(e) {
      e.preventDefault();
      this.error = null;
      this.submissionInProgress = true;
      this.standardRequest(
        { method: "POST", data: { formFields: this.formData } },
        `form/submit/${this.formKey}`,
        (res) => {
          if (res.status === 200) {
            if (res.data.code === 200 && res.data.formId) {
              this.formId = res.data.formId;
            } else {
              this.submitted = true;
            }
          }
          this.submissionInProgress = true;
        },
        (err) => {
          console.error("An Error!", err, err.response);

          if (err.response && err.response.data && err.response.data.msg) {
            this.error = err.response.data.msg;
          }

          this.submissionInProgress = false;
        }
      );
    },
    verify() {
      this.verificationTriggered = true;
    },
    getFieldInfo(identifier) {
      return this.fieldInfo[identifier];
    },
  },
  computed: {
    fieldInfo() {
      const fields = {};

      for (let group of this.formInfo.groups) {
        for (let field of group.fields) {
          fields[field.identifier] = field;
        }
      }

      return fields;
    },
    allRequiredFieldsSet() {
      for (let field in this.fieldInfo) {
        if (!(field in this.formData)) {
          return false;
        }
      }

      return true;
    },
    preview() {
      return this.formInfo.mailTemplate.replaceAll(
        /{{\s*([^\s]+)\s*}}/g,
        (match, identifier) => {
          const fieldInfo = this.getFieldInfo(identifier);

          if (fieldInfo === undefined) {
            throw Error(`Field not found ${identifier}`);
          }

          const value = this.formData[identifier];

          if (value === undefined) {
            return "[...]";
          }

          if (fieldInfo.type === "choice") {
            // resolve localized choices

            const selectedOption = fieldInfo.options.choices[value];

            if (selectedOption === undefined) {
              throw Error(`Unknown option ${value}`);
            }

            return selectedOption[this.formInfo.mailLocale || "de"];
          }

          return value;
        }
      );
    },
  },
};
